<template>
  <div class="edit-platform">
    <!--标题-->
    <!--    <div class="breadcrumb" style="background: #fff">{{ $route.params.title }}</div>-->
    <div class="breadcrumb" style="background: #fff">编辑平台</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
        <el-form-item label="平台号:" prop="code">
          <!-- <span v-permission="'crm:admin:store:specialInfo'">{{ruleForm.code}}</span> -->
          <el-input v-model="ruleForm.codeNum" @input="checkCode" :disabled="!$hasPermission('crm:admin:store:specialInfo') || $hasPermission('crm:admin:store:updateColor')">
            <template slot="prepend">{{ ruleForm.tag }}</template>
          </el-input>
          <el-button round @click="checkRepeat" v-if="!isRepeat">检查重复</el-button>
          <p class="color-red" ref="repeatRef"></p>
        </el-form-item>
        <el-form-item label="业务:" prop="salesman" v-if="type !== 0">
          <span style="display:inline-block;width:180px">{{ ruleForm.salesman === undefined ? '' : ruleForm.salesman.fullName }}</span>
          <el-button style="margin-left:20px" v-if="$hasPermission('crm:admin:store:specialInfo') && !$hasPermission('crm:admin:store:updateColor')" round
            @click="$router.push({ path: './changesalesman', query: { id: $route.query.id } })">变更业务 </el-button>
        </el-form-item>
        <el-form-item label="平台名称:" prop="name">
          <el-input v-model="ruleForm.name" max="20" v-if="$route.query.auditStatus !== 'HANDLE'" :disabled="$hasPermission('crm:admin:store:updateColor')"></el-input>
          <span v-if="$route.query.auditStatus === 'HANDLE'">{{ ruleForm.name }}</span>
        </el-form-item>
        <el-form-item label="公司名称:" prop="companyName">
          <el-input v-model="ruleForm.companyName" max="20" v-if="$route.query.auditStatus !== 'HANDLE'" :disabled="$hasPermission('crm:admin:store:updateColor')"></el-input>
          <span v-if="$route.query.auditStatus === 'HANDLE'">{{ ruleForm.companyName }}</span>
        </el-form-item>
        <el-form-item label="手机号:" prop="phone">
          <el-input v-model="ruleForm.phone" v-if="$route.query.auditStatus !== 'HANDLE'" width="180px" :disabled="$hasPermission('crm:admin:store:updateColor')"></el-input>
          <span v-if="$route.query.auditStatus === 'HANDLE'" style="display:inline-block;width:180px">{{ ruleForm.phone }}</span>
          <el-button style="margin-left:20px" v-if="$hasPermission('crm:admin:store:resetPhone') && !$hasPermission('crm:admin:store:updateColor')" round @click="changePhone">更换 </el-button>
        </el-form-item>
        <!-- v-if="$route.query.auditStatus !== 'HANDLE'" -->
        <el-form-item label="公司地区:" prop="address" :required="true">
          <el-select v-model="selectAddress.sheng" value-key="code" @change="getAllshi" clearable :disabled="$hasPermission('crm:admin:store:updateColor')">
            <el-option v-for="(option, index) in address.sheng" :key="'provinces' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.shi" value-key="id" @change="getAllQu" clearable :disabled="$hasPermission('crm:admin:store:updateColor')">
            <el-option v-for="(option, index) in address.shi" :key="'city' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.qu" value-key="id" clearable :disabled="$hasPermission('crm:admin:store:updateColor')">
            <el-option v-for="(option, index) in address.qu" :key="'region' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="公司地区:" prop="address" v-if="$route.query.auditStatus === 'HANDLE'">
          <span>{{ selectAddress.sheng.name + selectAddress.shi.name + selectAddress.qu.name }}</span>
        </el-form-item> -->
        <el-form-item label="公司详细地址:" prop="address" :required="true">
          <!-- v-if="$route.query.auditStatus !== 'HANDLE'"  -->
          <el-input v-model="ruleForm.address.fullAddress" style="width: 400px" @input="changeDetail($event)" max="80" :disabled="$hasPermission('crm:admin:store:updateColor')"></el-input>
          <!-- <span v-if="$route.query.auditStatus === 'HANDLE'">{{ ruleForm.address.fullAddress }}</span> -->
        </el-form-item>
        <el-form-item label="营业执照:">
          <!--  v-if="$route.query.auditStatus !== 'HANDLE'" -->
          <div class="upload-img" v-if="!ruleForm.licenseUrl && !$hasPermission('crm:admin:store:updateColor')">
            <input type="file" name="" id="input_img" @change="upload($event)" />
            <div @click="uploadImg()" class="recharge-ok">上传文件</div>
          </div>
          <div id="show_img" v-if="ruleForm.licenseUrl !== undefined">
            <img :src="ruleForm.licenseUrl" alt="">
          </div>
          <p v-if="!ruleForm.licenseUrl" style="color: #999">支持格式：.jpg.png ，单个文件不能超过10MB，再次上传将替换</p>
        </el-form-item>
        <!-- <el-form-item label="子管理员订单隔离:" prop="subDataIsolation">
          <el-switch v-model="ruleForm.subDataIsolation" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item> -->
        <el-form-item label="平台类型:" class="form-select" prop="storeTypeBean.id">
          <span v-if="$route.query.auditStatus === 'HANDLE'">{{ ruleForm.storeTypeBean === undefined ? "" : ruleForm.storeTypeBean.name }}</span>
          <el-select v-model="ruleForm.storeTypeBean.id" v-if="$route.query.auditStatus !== 'HANDLE'" placeholder="请选择" class="customer-select" @change="ruleForm.startups = 0"
            :disabled="$hasPermission('crm:admin:store:updateColor')">
            <el-option :label="item.name" :value="item.id" v-for="item in platformType" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否初创平台:" prop="startups" v-if="ruleForm.storeTypeBean.id == 10010 || ruleForm.storeTypeBean.name == '婚纱'">
          <el-switch v-model="ruleForm.startups" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
            :disabled="$hasPermission('crm:admin:store:updateColor')"></el-switch>
        </el-form-item>
        <el-form-item label="影像季上传设计版模块:" prop="showProductCenter" v-show="false">
          <el-switch v-model="ruleForm.showProductCenter" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" @change="showProductCenterChange"
            :disabled="$hasPermission('crm:admin:store:updateColor')"></el-switch>
        </el-form-item>
        <el-form-item label="产品中心:" prop="productCenter" v-if="ruleForm.showProductCenter">
          <el-switch v-model="ruleForm.productCenter" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
            :disabled="$hasPermission('crm:admin:store:updateColor')"></el-switch>
        </el-form-item>
        <el-form-item label="是否调色:" prop="colorType">
          <el-select clearable v-model="ruleForm.colorType">
            <el-option :label="item.name" :value="item.id" v-for="item in colorTypes" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设置可取消订单时间（小时）:" class="form-select">
          <!-- <el-input v-model="ruleForm.orderToErpDelayTime" style="width: 100px" type="number"></el-input> -->
          <el-input-number v-model="ruleForm.orderToErpDelayTime" controls-position="right" @change="timeChange" :min="0" :precision="2"
            :disabled="$hasPermission('crm:admin:store:updateColor')"></el-input-number>
          <p style="color: #ff0d00">注：设置的时间越长，工厂接收到订单的时间越晚</p>
        </el-form-item>
      </el-form>
    </div>
    <div class="third-title"><span>发货信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="ruleForm" :rules="rules" label-width="140px" class="demo-ruleForm">
        <el-form-item label="发货目的地:" v-if="$hasPermission('crm:admin:store:specialInfo') && !$hasPermission('crm:admin:store:updateColor')">
          <el-radio v-model="ruleForm.sendFlag" label="0">平台地址</el-radio>
          <el-radio v-model="ruleForm.sendFlag" label="1">终端客户</el-radio>
        </el-form-item>
        <el-form-item label="发货目的地:" v-else> {{ +ruleForm.sendFlag === 0 ? '平台地址' : +ruleForm.sendFlag === 1 ? '终端客户' : '未定义' }} </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round @click="openSave" v-preventReClick>保存</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="saveDialog" width="30%">
      <span>是否确认修改？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveDialog = false">取 消</el-button>
        <el-button type="primary" @click="save" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
    <el-dialog title="修改手机号" :visible.sync="dialogPhoneVisible" width="30%">
      <el-form :model="dialogForm" :rules="dialogRules" ref="form" label-width="100px">
        <el-form-item label="旧手机号" prop="phone">
          <el-input v-model="dialogForm.phone" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新手机号" prop="newPhone">
          <el-input v-model="dialogForm.newPhone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogPhoneVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { storeTypeGetStoreTypeList, storeUpdateStore, checkStoreCode, storeUsable, addressGetCountyByCityId, addressGetCityByProvinceCode, addressGetAllProvince, storeQueryByStoreId, resetPhone } from '@/api/crm'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'

export default {
  name: 'EditPlatform',
  components: {
    CombinedDialog
  },
  data () {
    return {
      dialogPhoneVisible: false,
      dialogForm: {},
      orderToErpList: [{
        name: '1小时',
        value: 1
      }, {
        name: '2小时',
        value: 2
      }, {
        name: '从不',
        value: 0
      }],
      saveMsg: '',
      saveDialog: false,
      selectAddress: {
        sheng: {
          name: ''
        },
        shi: {
          name: ''
        },
        qu: {
          name: ''
        }
      },
      type: '',
      btnContent: '',
      address: {
        sheng: [],
        shi: [],
        qu: []
      },
      ruleForm: {
        address: {
          city: '',
          cityId: '',
          county: '',
          countyId: '',
          fullAddress: '',
          id: '',
          province: '',
          provinceCode: ''
        },
        storeTypeBean: {

        },
        orderToErpDelayTime: 0,
        colorType: null
      },
      dialogRules: {
        newPhone: [
          {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          },
          {
            validator: this.$FormRules.checkPhone,
            trigger: 'blur'
          }
        ]
      },
      rules: {
        'storeTypeBean.id': [
          {
            required: true,
            message: '请选择平台类型',
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: '请填写平台名称',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          },
          {
            validator: this.$FormRules.checkPhone,
            trigger: 'blur'
          }
        ],
        companyName: [
          {
            min: 1,
            max: 20,
            message: '长度不能超过20个字符',
            trigger: 'blur'
          }
        ],
        address: {
          type: 'object',
          required: false,
          fields: {
            fullAddress: {
              min: 1,
              max: 80,
              message: '长度不能超过80个字符',
              trigger: 'blur'
            }
          }
        },
        platformTypeid: [{
          required: true,
          message: '请选择平台类型',
          trigger: 'change'
        }],
        sendFlag: [{
          required: true,
          message: '发货目的地:',
          trigger: 'change'
        }]
      },
      isRepeat: true,
      isCheckedRepeat: true,
      arr: '',
      cityArr: [],
      districtArr: [],
      platformType: [],
      colorTypes: [{
        name: '根据产品设置调色',
        id: 0
      }, {
        name: '全不调色',
        id: 1
      }, {
        name: '全调色',
        id: 2
      }],
      flag: false
    }
  },
  created () {
    this.init()
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    showProductCenterChange (val) {
      console.log('val', val)
      if (val == 1) {
        this.ruleForm.productCenter = 1
      } else {
        this.ruleForm.productCenter = 0
      }
    },
    timeChange (value) {
      console.log('value', value)
    },
    init () {
      if (this.$checkAwsSdk('product')) {
        this.$store.dispatch('awsSdk/getAwsSdk', 'product')
      }

      this.getAllSheng()

      storeTypeGetStoreTypeList().then((res) => {
        this.platformType = res.data.data
      })
      storeQueryByStoreId(this.$route.query.id).then((res) => {
        if (res.data.success) {
          let obj = JSON.parse(JSON.stringify(res.data.data))
          obj.phone = this.$msg.filterBridal(res.data.data.phone)
          if (obj.storeTypeBean === undefined) {
            obj.storeTypeBean = {}
          }
          obj.tag = obj.code.slice(0, obj.code.indexOf('-') + 1)
          obj.codeNum = obj.code.slice(obj.code.indexOf('-') + 1)
          this.ruleForm = obj
          // this.ruleForm.code = obj.tag + obj.codeNum // 修改婚纱平台前缀
          console.log('this.ruleForm', this.ruleForm)
          this.ruleForm.sendFlag += ''
          if (this.ruleForm.address) {
            this.selectAddress = {
              sheng: {
                code: this.ruleForm.address.provinceCode,
                name: this.ruleForm.address.province
              },
              shi: {
                id: this.ruleForm.address.cityId,
                name: this.ruleForm.address.city
              },
              qu: {
                id: this.ruleForm.address.countyId,
                name: this.ruleForm.address.county
              }
            }
            this.getAllshi()
            this.getAllQu()
          } else {
            this.ruleForm.address = {

            }
          }
          // this.flag = true
        } else {

        }
      })
    },
    save () {
      storeUpdateStore(this.saveMsg).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.$router.go(-1)
        }
      })
    },
    getAllQu () {
      if (this.selectAddress.shi === '') {
        this.selectAddress.qu = ''
        return
      }
      addressGetCountyByCityId(this.selectAddress.shi.id).then(res => {
        if (res.data.success) {
          this.address.qu = res.data.data
          if (res.data.data.filter(item => { return item.id === this.selectAddress.qu.id }).length === 0) {
            this.selectAddress.qu = res.data.data[0]
          }
        }
      })
    },
    getAllshi () {
      if (this.selectAddress.sheng === '') {
        this.selectAddress.shi = ''
        this.selectAddress.qu = ''
        return
      }
      addressGetCityByProvinceCode(this.selectAddress.sheng.code).then(res => {
        if (res.data.success) {
          this.address.shi = res.data.data
          if (res.data.data.filter(item => { return item.id === this.selectAddress.shi.id }).length === 0) {
            this.selectAddress.shi = res.data.data[0]
            this.selectAddress.qu = ''
            this.getAllQu()
          }
        }
      })
    },
    getAllSheng () {
      addressGetAllProvince().then(res => {
        if (res.data.success) {
          this.address.sheng = res.data.data
        }
      })
    },
    uploadImg () {
      document.querySelector('#input_img').click()
    },
    checkCode () {
      this.ruleForm.code = this.ruleForm.tag + this.ruleForm.codeNum
      if (this.ruleForm.code === this.$route.query.code) {
        this.isRepeat = true
        this.$refs.repeatRef.innerText = ''
      } else {
        this.isRepeat = false
        this.isCheckedRepeat = false
      }
    },
    checkRepeat () {
      this.isCheckedRepeat = true
      checkStoreCode({ storeCode: this.ruleForm.code, id: this.$route.query.id }).then((res) => {
        if (!res.data.data.exist) {
          this.$refs.repeatRef.innerText = '校验成功'
          this.isRepeat = true
        } else {
          this.$refs.repeatRef.innerText = '已存在相同的平台号'
          this.isRepeat = 'has'
        }
      })
    },
    changeAddress (val) {
      this.ruleForm.address = val
    },
    changeDetail (e) {
      this.$forceUpdate()
    },
    openSave () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.isRepeat) return this.$message.error('请先验证平台号')
          if (this.isRepeat === 'has') {
            this.$message.error('已存在相同的平台号')
            return
          }
          let systemCode = (this.ruleForm.storeTypeid == 10010 || this.ruleForm.storeTypeid == 10012) ? 'BRIDAL' : this.ruleForm.storeTypeid == 10013 ? ' VIDEO' : 'PIYA'
          storeUsable({ act: 1, name: this.ruleForm.name, storeId: this.$route.query.id, systemCode }).then(res => {
            if (res.data.success) {
              if (res.data.data.exist) {
                this.$message.error('平台名称已存在')
              } else {
                let addressVo = {
                  city: this.selectAddress.shi.name,
                  cityId: this.selectAddress.shi.id,
                  county: this.selectAddress.qu.name,
                  countyId: this.selectAddress.qu.id,
                  fullAddress: this.ruleForm.address.fullAddress,
                  id: this.ruleForm.address ? this.ruleForm.address.id : '',
                  province: this.selectAddress.sheng.name,
                  provinceCode: this.selectAddress.sheng.code
                }
                // if (JSON.stringify(addressVo.county !== undefined) !== JSON.stringify(addressVo.fullAddress !== undefined)) {
                if (!addressVo.county !== !addressVo.fullAddress) {
                  this.$message.error('请完善地址信息')
                  return
                }
                if (!addressVo.county && !addressVo.fullAddress) {
                  this.$message.error('请完善地址信息')
                  return
                }
                let list = {
                  addressVo: addressVo,
                  code: this.ruleForm.code,
                  companyName: this.ruleForm.companyName,
                  id: this.ruleForm.id,
                  licenseUrl: this.ruleForm.licenseUrl,
                  name: this.ruleForm.name,
                  phone: this.ruleForm.phone,
                  storeTypeid: this.ruleForm.storeTypeBean.id,
                  sendFlag: this.ruleForm.sendFlag,
                  orderToErpDelayTime: this.ruleForm.orderToErpDelayTime,
                  startups: this.ruleForm.startups,
                  showProductCenter: this.ruleForm.showProductCenter,
                  productCenter: this.ruleForm.productCenter,
                  colorType: this.ruleForm.colorType
                  // subDataIsolation: this.ruleForm.subDataIsolation
                }
                this.saveMsg = list
                this.saveDialog = true
                // this.$refs.dialogRef.show('checktrue', '确定提示',
                //   '保存确定<br><span style="font-size: 14px;color: #999">是否确定保存修改</span>', list, 'savePlatform', 'savePlatform')
              }
            }
          })
        } else {
          return false
        }
      })
    },
    upload (e) {
      if (e.target.files[0].type !== 'image/jpeg' && e.target.files[0].type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (e.target.files[0].size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '正在上传图片',
        spTEXT: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadWebImg(e.target.files[0], this.$store.state.awsSdk.product.s3).then(res => {
        this.ruleForm.licenseUrl = res
        this.$forceUpdate()
        loading.close()
      })
    },
    changePhone () {
      this.dialogForm.phone = this.ruleForm.phone
      this.dialogPhoneVisible = true
    },
    dialogFormSubmit () {
      resetPhone({
        id: this.$route.query.id,
        phone: this.dialogForm.newPhone
      }).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.ruleForm.phone = this.dialogForm.newPhone
        }
        this.dialogPhoneVisible = false
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

.el-input-number {
  line-height: 30px !important;
}

/deep/ .el-input-number__decrease {
  line-height: 15px !important;
}

/deep/ .el-input-number__increase {
  line-height: 15px !important;
}
</style>
